import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=74a24338&"
import script from "./NewsCard.vue?vue&type=script&lang=ts&"
export * from "./NewsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports